/**
 * Created by Kaku.Guo on 2018/12/12.
 */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import ShoppingCartView from './ShoppingCartView';
import { getMessage } from '../index';
import { getAssetPath } from '../../utils';
import { ShoppingCartActions } from '../../actions';

const mapStateToProps = (state) => {
    const { isLoadingOffer, isReachMaxLimit, offers, offerIds, totalPrice, errorMessage } = state.get('shoppingCart').toJS();
    const { isLauncher, shoppingCartMaxAmount } = state.get('config').toJS();
    return {
        isLoadingOffer,
        isReachMaxLimit,
        offers,
        offerIds,
        totalPrice,
        errorMessage,
        isLauncher,
        shoppingCartMaxAmount
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        listOffers: () => {dispatch(ShoppingCartActions.getOffers());},
        removeOffer: (model) => {dispatch(ShoppingCartActions.removeOffer(model));},
        clearOffers: () => {dispatch(ShoppingCartActions.clearOffers());},
        purchase: (model) => {dispatch(ShoppingCartActions.purchase(model));}
    };
};

@connect(mapStateToProps, mapDispatchToProps)
class ShoppingCart extends ShoppingCartView {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
    }
    toggleOpen = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const { isOpen } = this.state;
        if (!isOpen) {
            this.props.listOffers();
        }
        this.setState({
            isOpen: !isOpen
        });
    };
    isOpen = () => (this.state.isOpen);
    getMessage = (code, args) => {
        const { messages } = this.props;
        return getMessage(messages, code, args);
    };
    getOffers = () => {
        const { offers = [] } = this.props;
        return offers;
    };
    getDisplayOfferCount = () => {
        const { offerIds = [] } = this.props;
        return offerIds.length;
    };
    getOfferCount = () => {
        const { offers = [] } = this.props;
        return offers.length;
    };
    isReachMaxLimit = () => (this.props.isReachMaxLimit);
    isLoadingCart = () => (this.props.isLoadingOffer);
    getDisplayImage = ({ keyImages }) => {
        let image = getAssetPath('logo-epic.svg');
        if (keyImages && keyImages.length) {
            const featuredImage = keyImages.find(ki => ki.type === 'Featured');
            if (featuredImage && featuredImage.url) {
                image = featuredImage.url;
            }
        }
        return image;
    };
    getDisplayPrice = ({ discounted, price, discountPrice }) => {
        if (discounted) {
            return (
                <Fragment>
                    <span className="origin-price">{price}</span>
                    {discountPrice}
                </Fragment>
            );
        }
        return price;
    };

    getTotalPrice = () => (this.props.totalPrice);

    handleRemoveOffer = ({ id }) => (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.props.removeOffer({ offerId: id });
    };

    handlePurchase = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const { offers, offerIds, purchase, clearOffers } = this.props;
        if (offers.length) {
            const { namespace } = offers[0];
            purchase({
                namespace,
                offers: offerIds,
                quantity: 1,
                isShoppingCart: true,
                success: () => {
                    clearOffers();
                }
            });
            this.setState({
                isOpen: false
            });
        }
    };
    getLoadingImage = () => {
        const { isLauncher } = this.props;
        if (isLauncher) {
            return getAssetPath('loading-spin-launcher.svg');
        }
        return getAssetPath('loading-spin.svg');
    };
    getMaxLimitArgs = () => ([this.props.shoppingCartMaxAmount]);

    handleBlur = (e) => {
        if (e && !e.currentTarget.contains(e.relatedTarget)) {
            this.setState({ isOpen: false });
        }
    };
}
export default ShoppingCart;